module.exports = __webpack_public_path__ + "static/media/icon_adhoc.08622891.svg";